import Vue from 'vue';
import debounce from './debounce'
import onlyNum from './directive/onlyNum';
import onlyInteger from './directive/onlyInteger';
import inputMoney from './directive/inputMoney';
import watchSticky from "./directive/watchSticky";
import omitHide from "./directive/omitHide";
import {tableSticky} from 'lp-vue'
Vue.directive('tableSticky', tableSticky)
// 监听sticky滚动
Vue.directive('jp-watch-sticky', watchSticky);

// 超出隐藏
Vue.directive('jp-omit-hide', omitHide);
/**
 * @description只能输入数字 v-only-num
 * @param el
 */
Vue.directive('onlyNum', {update: onlyNum});
/**
 * @description只能输入数字 v-only-integer
 * @param el
 */
Vue.directive('onlyInteger', {update: onlyInteger});
Vue.directive('inputMoney',
  {
    inserted: inputMoney.inserted,
    bind: inputMoney.bind,
    update: inputMoney.update,
    unbind: inputMoney.unbind
  }
);

// 自动获取焦点
Vue.directive('focus', {
  inserted: function (el) {
    el.querySelector('input').focus()
  }
});

// 防连点
Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
});

// 防抖
Vue.directive('debounce', debounce);

// 点击空白隐藏
Vue.directive('clickOutside', {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  },
})

// 点击空白隐藏
Vue.directive('mousewheel', {
  // 初始化指令
  bind(el, binding) {
    mousewheel(el, binding.value);
  },
})
import normalizeWheel from 'normalize-wheel';
const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const mousewheel = function(element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function(event) {
      const normalized = normalizeWheel(event);
      callback && callback.apply(this, [event, normalized]);
    });
  }
};
